import React from 'react';
import './Footer.css';
import logo from '../assets/logo-footer.png'; // ✅ adjust path if needed

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Logo and company info */}
        <div className="footer-section footer-logo">
          <img src={logo} alt="IndoDefTech Logo" className="footer-logo-img w3-grey-scale" />
          <h4 className="h5">Indoglobal Deftech Llp</h4>
          <p className="w3-widew3-small">
            Innovation  Integrity Impact 
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section w3-hide-small w3-hide">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/aboutus">About Us</a></li>

            <li><a href="/team">Team</a></li>
            <li><a href="/services">Services</a></li>

            <li><a href="/services">Partners</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
 


        {/* Contact Info */}
        <div className="footer-section">
         <h4>Our Offices</h4>
          <div className="office">
            <h5>Noida</h5>
            <p>E-53, 3rd Floor, Sector 63<br />Noida, Uttar Pradesh 201301</p>
          </div>
          <div className="office">
            <h5>Gurugram</h5>
            <p>AF-005-007, 1st Floor, Conscient One<br />Sector 109, Gurugram, Haryana 122006</p>
          </div>
        </div>


        {/* Contact Info */}
        <div className="footer-section">
          <h4>Contact</h4>
          <p>info@indodeftech.com</p>
          <p> +91 99903 30700 </p>
        </div>




      </div>



      {/* Bottom line */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} IndoDefTech. All rights reserved. &nbsp;|&nbsp;
          <a href="/privacy-policy" className="footer-link">Privacy Policy</a> &nbsp;|&nbsp;
          <a href="/terms" className="footer-link">Terms & Conditions</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
